import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import Contact from './pages/Contact';
import WebDevelopment from './pages/services/WebDevelopment';
import ResponsiveDesign from './pages/services/ResponsiveDesign';
import EcommerceSolutions from './pages/services/EcommerceSolutions';
import { routes, BASE_PATH } from './config/routes';
import './styles/variables.css';
import './styles/App.css';

// Temporary placeholder component for pages that aren't created yet
const PlaceholderPage: React.FC<{ pageName: string }> = ({ pageName }) => (
  <div style={{ padding: '50px 20px', textAlign: 'center' }}>
    <h1>{pageName} Page</h1>
    <p>This page is under construction.</p>
  </div>
);

const App: React.FC = () => {
  const getComponent = (componentName: string) => {
    switch (componentName) {
      case 'Home':
        return <Home />;
      case 'Services':
        return <Services />;
      case 'Portfolio':
        return <Portfolio />;
      case 'About':
        return <About />;
      case 'Contact':
        return <Contact />;
      case 'WebDevelopment':
        return <WebDevelopment />;
      case 'ResponsiveDesign':
        return <ResponsiveDesign />;
      case 'EcommerceSolutions':
        return <EcommerceSolutions />;
      default:
        return <PlaceholderPage pageName={componentName} />;
    }
  };

  return (
    <Router basename={BASE_PATH}>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={getComponent(route.component)}
              />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
